module.exports = __webpack_public_path__ + "static/img/5.b7ef014.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/zh/5.png
// module id = CPsb
// module chunks = 0